/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplyTypeChangeInputBody,
  BlockTypesOutputBody,
  ContentFieldsChangeTypeHeaders,
  ContentFieldsReorderHeaders,
  ContentFieldsTypeChangePreviewParams,
  ContentFieldsUpdateHeaders,
  ContentTypesListParams,
  ContentTypesUpdateHeaders,
  CreateFieldInputBody,
  CreateTypeInputBody,
  ErrorModel,
  FieldBody,
  FieldTypesOutputBody,
  ImpactInputBody,
  ImpactOutputBody,
  ImportOutputBody,
  MenuIconsOutputBody,
  RecordTransferInputBody,
  RecordTransferOutputBody,
  RecordTransferPreviewOutputBody,
  RefreshApplyInputBody,
  RefreshBody,
  ReorderInputBody,
  ReorderTypesInputBody,
  SchemaFile,
  SchemaImportParams,
  SchemaTransferPreviewParams,
  TemplatesOutputBody,
  TransferApplyInputBody,
  TransferBody,
  TransferPreviewOutputBody,
  TransfersOutputBody,
  TypeBody,
  TypeChangeOutputBody,
  TypeWithFieldsOutputBody,
  TypesOutputBody,
  UpdateFieldInputBody,
  UpdateTypeInputBody,
  UsageOutputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type contentTypesDeleteResponse204 = {
  data: void
  status: 204
}

export type contentTypesDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesDeleteResponseSuccess = (contentTypesDeleteResponse204) & {
  headers: Headers;
};
export type contentTypesDeleteResponseError = (contentTypesDeleteResponse401 | contentTypesDeleteResponse403 | contentTypesDeleteResponse404 | contentTypesDeleteResponse422 | contentTypesDeleteResponse500) & {
  headers: Headers;
};

export type contentTypesDeleteResponse = (contentTypesDeleteResponseSuccess | contentTypesDeleteResponseError)

export const getContentTypesDeleteUrl = (typeId: string,) => {




  return `/content-types/${typeId}`
}

/**
 * Тип уезжает в корзину вместе со своими записями.
 * @summary Удалить тип
 */
export const contentTypesDelete = async (typeId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesDeleteResponse> => {

  return facetaFetch<contentTypesDeleteResponse>(getContentTypesDeleteUrl(typeId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getContentTypesDeleteQueryKey = (typeId: string,) => {
    return [
    'DELETE', `/content-types/${typeId}`
    ] as const;
    }


export const getContentTypesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesDelete>>, TError = ErrorModel>(typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesDeleteQueryKey(typeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesDelete>>> = ({ signal }) => contentTypesDelete(typeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesDelete>>>
export type ContentTypesDeleteQueryError = ErrorModel


export function useContentTypesDelete<TData = Awaited<ReturnType<typeof contentTypesDelete>>, TError = ErrorModel>(
 typeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesDelete>>,
          TError,
          Awaited<ReturnType<typeof contentTypesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesDelete<TData = Awaited<ReturnType<typeof contentTypesDelete>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesDelete>>,
          TError,
          Awaited<ReturnType<typeof contentTypesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesDelete<TData = Awaited<ReturnType<typeof contentTypesDelete>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить тип
 */

export function useContentTypesDelete<TData = Awaited<ReturnType<typeof contentTypesDelete>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesDeleteQueryOptions(typeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesGetResponse200 = {
  data: TypeWithFieldsOutputBody
  status: 200
}

export type contentTypesGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesGetResponseSuccess = (contentTypesGetResponse200) & {
  headers: Headers;
};
export type contentTypesGetResponseError = (contentTypesGetResponse401 | contentTypesGetResponse403 | contentTypesGetResponse404 | contentTypesGetResponse422 | contentTypesGetResponse500) & {
  headers: Headers;
};

export type contentTypesGetResponse = (contentTypesGetResponseSuccess | contentTypesGetResponseError)

export const getContentTypesGetUrl = (typeId: string,) => {




  return `/content-types/${typeId}`
}

/**
 * Поля приходят вместе с типом, включая скрытые: экран конструктора показывает и то и другое сразу, и вторым запросом это только мигало бы.
 * @summary Тип вместе с полями
 */
export const contentTypesGet = async (typeId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesGetResponse> => {

  return facetaFetch<contentTypesGetResponse>(getContentTypesGetUrl(typeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentTypesGetQueryKey = (typeId: string,) => {
    return [
    `/content-types/${typeId}`
    ] as const;
    }


export const getContentTypesGetQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesGet>>, TError = ErrorModel>(typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesGetQueryKey(typeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesGet>>> = ({ signal }) => contentTypesGet(typeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesGetQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesGet>>>
export type ContentTypesGetQueryError = ErrorModel


export function useContentTypesGet<TData = Awaited<ReturnType<typeof contentTypesGet>>, TError = ErrorModel>(
 typeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesGet>>,
          TError,
          Awaited<ReturnType<typeof contentTypesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesGet<TData = Awaited<ReturnType<typeof contentTypesGet>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesGet>>,
          TError,
          Awaited<ReturnType<typeof contentTypesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesGet<TData = Awaited<ReturnType<typeof contentTypesGet>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Тип вместе с полями
 */

export function useContentTypesGet<TData = Awaited<ReturnType<typeof contentTypesGet>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesGetQueryOptions(typeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesUpdateResponse200 = {
  data: TypeBody
  status: 200
}

export type contentTypesUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type contentTypesUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesUpdateResponseSuccess = (contentTypesUpdateResponse200) & {
  headers: Headers;
};
export type contentTypesUpdateResponseError = (contentTypesUpdateResponse401 | contentTypesUpdateResponse403 | contentTypesUpdateResponse404 | contentTypesUpdateResponse409 | contentTypesUpdateResponse422 | contentTypesUpdateResponse500) & {
  headers: Headers;
};

export type contentTypesUpdateResponse = (contentTypesUpdateResponseSuccess | contentTypesUpdateResponseError)

export const getContentTypesUpdateUrl = (typeId: string,) => {




  return `/content-types/${typeId}`
}

/**
 * @summary Изменить тип
 */
export const contentTypesUpdate = async (typeId: string,
    updateTypeInputBody: NonReadonly<UpdateTypeInputBody>,
    headers: ContentTypesUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentTypesUpdateResponse>(getContentTypesUpdateUrl(typeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTypeInputBody)
  }
);}





export const getContentTypesUpdateQueryKey = (typeId: string,
    updateTypeInputBody?: NonReadonly<UpdateTypeInputBody>,) => {
    return [
    'PATCH', `/content-types/${typeId}`, updateTypeInputBody
    ] as const;
    }


export const getContentTypesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesUpdate>>, TError = ErrorModel>(typeId: string,
    updateTypeInputBody: NonReadonly<UpdateTypeInputBody>,
    headers: ContentTypesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesUpdateQueryKey(typeId,updateTypeInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesUpdate>>> = ({ signal }) => contentTypesUpdate(typeId,updateTypeInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesUpdate>>>
export type ContentTypesUpdateQueryError = ErrorModel


export function useContentTypesUpdate<TData = Awaited<ReturnType<typeof contentTypesUpdate>>, TError = ErrorModel>(
 typeId: string,
    updateTypeInputBody: NonReadonly<UpdateTypeInputBody>,
    headers: ContentTypesUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesUpdate>>,
          TError,
          Awaited<ReturnType<typeof contentTypesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesUpdate<TData = Awaited<ReturnType<typeof contentTypesUpdate>>, TError = ErrorModel>(
 typeId: string,
    updateTypeInputBody: NonReadonly<UpdateTypeInputBody>,
    headers: ContentTypesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesUpdate>>,
          TError,
          Awaited<ReturnType<typeof contentTypesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesUpdate<TData = Awaited<ReturnType<typeof contentTypesUpdate>>, TError = ErrorModel>(
 typeId: string,
    updateTypeInputBody: NonReadonly<UpdateTypeInputBody>,
    headers: ContentTypesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить тип
 */

export function useContentTypesUpdate<TData = Awaited<ReturnType<typeof contentTypesUpdate>>, TError = ErrorModel>(
 typeId: string,
    updateTypeInputBody: NonReadonly<UpdateTypeInputBody>,
    headers: ContentTypesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesUpdateQueryOptions(typeId,updateTypeInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsCreateResponse201 = {
  data: FieldBody
  status: 201
}

export type contentFieldsCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type contentFieldsCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsCreateResponseSuccess = (contentFieldsCreateResponse201) & {
  headers: Headers;
};
export type contentFieldsCreateResponseError = (contentFieldsCreateResponse401 | contentFieldsCreateResponse403 | contentFieldsCreateResponse404 | contentFieldsCreateResponse409 | contentFieldsCreateResponse422 | contentFieldsCreateResponse500) & {
  headers: Headers;
};

export type contentFieldsCreateResponse = (contentFieldsCreateResponseSuccess | contentFieldsCreateResponseError)

export const getContentFieldsCreateUrl = (typeId: string,) => {




  return `/content-types/${typeId}/fields`
}

/**
 * Ключ поля выбирается один раз и не меняется никогда: под ним лежат значения во всех уже созданных записях, и переименование их осиротит.
 * @summary Добавить поле
 */
export const contentFieldsCreate = async (typeId: string,
    createFieldInputBody: NonReadonly<CreateFieldInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentFieldsCreateResponse>(getContentFieldsCreateUrl(typeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFieldInputBody)
  }
);}





export const getContentFieldsCreateQueryKey = (typeId: string,
    createFieldInputBody?: NonReadonly<CreateFieldInputBody>,) => {
    return [
    'POST', `/content-types/${typeId}/fields`, createFieldInputBody
    ] as const;
    }


export const getContentFieldsCreateQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsCreate>>, TError = ErrorModel>(typeId: string,
    createFieldInputBody: NonReadonly<CreateFieldInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsCreateQueryKey(typeId,createFieldInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsCreate>>> = ({ signal }) => contentFieldsCreate(typeId,createFieldInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsCreate>>>
export type ContentFieldsCreateQueryError = ErrorModel


export function useContentFieldsCreate<TData = Awaited<ReturnType<typeof contentFieldsCreate>>, TError = ErrorModel>(
 typeId: string,
    createFieldInputBody: NonReadonly<CreateFieldInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsCreate>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsCreate<TData = Awaited<ReturnType<typeof contentFieldsCreate>>, TError = ErrorModel>(
 typeId: string,
    createFieldInputBody: NonReadonly<CreateFieldInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsCreate>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsCreate<TData = Awaited<ReturnType<typeof contentFieldsCreate>>, TError = ErrorModel>(
 typeId: string,
    createFieldInputBody: NonReadonly<CreateFieldInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Добавить поле
 */

export function useContentFieldsCreate<TData = Awaited<ReturnType<typeof contentFieldsCreate>>, TError = ErrorModel>(
 typeId: string,
    createFieldInputBody: NonReadonly<CreateFieldInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsCreateQueryOptions(typeId,createFieldInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsReorderResponse204 = {
  data: void
  status: 204
}

export type contentFieldsReorderResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsReorderResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsReorderResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsReorderResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsReorderResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsReorderResponseSuccess = (contentFieldsReorderResponse204) & {
  headers: Headers;
};
export type contentFieldsReorderResponseError = (contentFieldsReorderResponse401 | contentFieldsReorderResponse403 | contentFieldsReorderResponse404 | contentFieldsReorderResponse422 | contentFieldsReorderResponse500) & {
  headers: Headers;
};

export type contentFieldsReorderResponse = (contentFieldsReorderResponseSuccess | contentFieldsReorderResponseError)

export const getContentFieldsReorderUrl = (typeId: string,) => {




  return `/content-types/${typeId}/fields/order`
}

/**
 * Порядок задаётся целиком: иначе два человека, переставляющие поля одновременно, получают перемешанный список.
 * @summary Переставить поля
 */
export const contentFieldsReorder = async (typeId: string,
    reorderInputBody: NonReadonly<ReorderInputBody>,
    headers: ContentFieldsReorderHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsReorderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentFieldsReorderResponse>(getContentFieldsReorderUrl(typeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderInputBody)
  }
);}





export const getContentFieldsReorderQueryKey = (typeId: string,
    reorderInputBody?: NonReadonly<ReorderInputBody>,) => {
    return [
    'PUT', `/content-types/${typeId}/fields/order`, reorderInputBody
    ] as const;
    }


export const getContentFieldsReorderQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsReorder>>, TError = ErrorModel>(typeId: string,
    reorderInputBody: NonReadonly<ReorderInputBody>,
    headers: ContentFieldsReorderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsReorderQueryKey(typeId,reorderInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsReorder>>> = ({ signal }) => contentFieldsReorder(typeId,reorderInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsReorder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsReorderQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsReorder>>>
export type ContentFieldsReorderQueryError = ErrorModel


export function useContentFieldsReorder<TData = Awaited<ReturnType<typeof contentFieldsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody: NonReadonly<ReorderInputBody>,
    headers: ContentFieldsReorderHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsReorder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsReorder>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsReorder<TData = Awaited<ReturnType<typeof contentFieldsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody: NonReadonly<ReorderInputBody>,
    headers: ContentFieldsReorderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsReorder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsReorder>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsReorder<TData = Awaited<ReturnType<typeof contentFieldsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody: NonReadonly<ReorderInputBody>,
    headers: ContentFieldsReorderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Переставить поля
 */

export function useContentFieldsReorder<TData = Awaited<ReturnType<typeof contentFieldsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody: NonReadonly<ReorderInputBody>,
    headers: ContentFieldsReorderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsReorderQueryOptions(typeId,reorderInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesRestoreResponse200 = {
  data: TypeBody
  status: 200
}

export type contentTypesRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesRestoreResponse409 = {
  data: ErrorModel
  status: 409
}

export type contentTypesRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesRestoreResponseSuccess = (contentTypesRestoreResponse200) & {
  headers: Headers;
};
export type contentTypesRestoreResponseError = (contentTypesRestoreResponse401 | contentTypesRestoreResponse403 | contentTypesRestoreResponse404 | contentTypesRestoreResponse409 | contentTypesRestoreResponse422 | contentTypesRestoreResponse500) & {
  headers: Headers;
};

export type contentTypesRestoreResponse = (contentTypesRestoreResponseSuccess | contentTypesRestoreResponseError)

export const getContentTypesRestoreUrl = (typeId: string,) => {




  return `/content-types/${typeId}/restore`
}

/**
 * @summary Восстановить тип
 */
export const contentTypesRestore = async (typeId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesRestoreResponse> => {

  return facetaFetch<contentTypesRestoreResponse>(getContentTypesRestoreUrl(typeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getContentTypesRestoreQueryKey = (typeId: string,) => {
    return [
    'POST', `/content-types/${typeId}/restore`
    ] as const;
    }


export const getContentTypesRestoreQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesRestore>>, TError = ErrorModel>(typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesRestoreQueryKey(typeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesRestore>>> = ({ signal }) => contentTypesRestore(typeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesRestore>>>
export type ContentTypesRestoreQueryError = ErrorModel


export function useContentTypesRestore<TData = Awaited<ReturnType<typeof contentTypesRestore>>, TError = ErrorModel>(
 typeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesRestore>>,
          TError,
          Awaited<ReturnType<typeof contentTypesRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesRestore<TData = Awaited<ReturnType<typeof contentTypesRestore>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesRestore>>,
          TError,
          Awaited<ReturnType<typeof contentTypesRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesRestore<TData = Awaited<ReturnType<typeof contentTypesRestore>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Восстановить тип
 */

export function useContentTypesRestore<TData = Awaited<ReturnType<typeof contentTypesRestore>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesRestoreQueryOptions(typeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesUsageResponse200 = {
  data: UsageOutputBody
  status: 200
}

export type contentTypesUsageResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesUsageResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesUsageResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesUsageResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesUsageResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesUsageResponseSuccess = (contentTypesUsageResponse200) & {
  headers: Headers;
};
export type contentTypesUsageResponseError = (contentTypesUsageResponse401 | contentTypesUsageResponse403 | contentTypesUsageResponse404 | contentTypesUsageResponse422 | contentTypesUsageResponse500) & {
  headers: Headers;
};

export type contentTypesUsageResponse = (contentTypesUsageResponseSuccess | contentTypesUsageResponseError)

export const getContentTypesUsageUrl = (typeId: string,) => {




  return `/content-types/${typeId}/usage`
}

/**
 * Сколько записей у типа и, для блока, на каких страницах он стоит. Показывается до удаления: «уйдут в корзину 340 записей», «блок стоит на 12 страницах».
 * @summary Где используется тип
 */
export const contentTypesUsage = async (typeId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesUsageResponse> => {

  return facetaFetch<contentTypesUsageResponse>(getContentTypesUsageUrl(typeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentTypesUsageQueryKey = (typeId: string,) => {
    return [
    `/content-types/${typeId}/usage`
    ] as const;
    }


export const getContentTypesUsageQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesUsage>>, TError = ErrorModel>(typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUsage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesUsageQueryKey(typeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesUsage>>> = ({ signal }) => contentTypesUsage(typeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesUsageQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesUsage>>>
export type ContentTypesUsageQueryError = ErrorModel


export function useContentTypesUsage<TData = Awaited<ReturnType<typeof contentTypesUsage>>, TError = ErrorModel>(
 typeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesUsage>>,
          TError,
          Awaited<ReturnType<typeof contentTypesUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesUsage<TData = Awaited<ReturnType<typeof contentTypesUsage>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesUsage>>,
          TError,
          Awaited<ReturnType<typeof contentTypesUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesUsage<TData = Awaited<ReturnType<typeof contentTypesUsage>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUsage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Где используется тип
 */

export function useContentTypesUsage<TData = Awaited<ReturnType<typeof contentTypesUsage>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesUsage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesUsageQueryOptions(typeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldTypesResponse200 = {
  data: FieldTypesOutputBody
  status: 200
}

export type contentFieldTypesResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldTypesResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldTypesResponseSuccess = (contentFieldTypesResponse200) & {
  headers: Headers;
};
export type contentFieldTypesResponseError = (contentFieldTypesResponse401 | contentFieldTypesResponse500) & {
  headers: Headers;
};

export type contentFieldTypesResponse = (contentFieldTypesResponseSuccess | contentFieldTypesResponseError)

export const getContentFieldTypesUrl = () => {




  return `/field-types`
}

/**
 * Справочник видов полей с названиями. Отдаётся сервером, а не переписывается на клиенте: набор закрыт кодом, и два его списка однажды разойдутся.
 * @summary Виды полей
 */
export const contentFieldTypes = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldTypesResponse> => {

  return facetaFetch<contentFieldTypesResponse>(getContentFieldTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentFieldTypesQueryKey = () => {
    return [
    `/field-types`
    ] as const;
    }


export const getContentFieldTypesQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldTypes>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldTypes>>> = ({ signal }) => contentFieldTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldTypesQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldTypes>>>
export type ContentFieldTypesQueryError = ErrorModel


export function useContentFieldTypes<TData = Awaited<ReturnType<typeof contentFieldTypes>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldTypes>>,
          TError,
          Awaited<ReturnType<typeof contentFieldTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldTypes<TData = Awaited<ReturnType<typeof contentFieldTypes>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldTypes>>,
          TError,
          Awaited<ReturnType<typeof contentFieldTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldTypes<TData = Awaited<ReturnType<typeof contentFieldTypes>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Виды полей
 */

export function useContentFieldTypes<TData = Awaited<ReturnType<typeof contentFieldTypes>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsHideResponse204 = {
  data: void
  status: 204
}

export type contentFieldsHideResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsHideResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsHideResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsHideResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsHideResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsHideResponseSuccess = (contentFieldsHideResponse204) & {
  headers: Headers;
};
export type contentFieldsHideResponseError = (contentFieldsHideResponse401 | contentFieldsHideResponse403 | contentFieldsHideResponse404 | contentFieldsHideResponse422 | contentFieldsHideResponse500) & {
  headers: Headers;
};

export type contentFieldsHideResponse = (contentFieldsHideResponseSuccess | contentFieldsHideResponseError)

export const getContentFieldsHideUrl = (fieldId: string,) => {




  return `/fields/${fieldId}`
}

/**
 * Поле пропадает из редактора, значения в записях остаются. Вернуть можно одним нажатием: скрывший поле по ошибке теряет не строку, а по значению в каждой записи.
 * @summary Скрыть поле
 */
export const contentFieldsHide = async (fieldId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsHideResponse> => {

  return facetaFetch<contentFieldsHideResponse>(getContentFieldsHideUrl(fieldId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getContentFieldsHideQueryKey = (fieldId: string,) => {
    return [
    'DELETE', `/fields/${fieldId}`
    ] as const;
    }


export const getContentFieldsHideQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsHide>>, TError = ErrorModel>(fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsHide>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsHideQueryKey(fieldId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsHide>>> = ({ signal }) => contentFieldsHide(fieldId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fieldId !== null && fieldId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsHide>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsHideQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsHide>>>
export type ContentFieldsHideQueryError = ErrorModel


export function useContentFieldsHide<TData = Awaited<ReturnType<typeof contentFieldsHide>>, TError = ErrorModel>(
 fieldId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsHide>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsHide>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsHide>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsHide<TData = Awaited<ReturnType<typeof contentFieldsHide>>, TError = ErrorModel>(
 fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsHide>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsHide>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsHide>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsHide<TData = Awaited<ReturnType<typeof contentFieldsHide>>, TError = ErrorModel>(
 fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsHide>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Скрыть поле
 */

export function useContentFieldsHide<TData = Awaited<ReturnType<typeof contentFieldsHide>>, TError = ErrorModel>(
 fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsHide>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsHideQueryOptions(fieldId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsUpdateResponse200 = {
  data: FieldBody
  status: 200
}

export type contentFieldsUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsUpdateResponseSuccess = (contentFieldsUpdateResponse200) & {
  headers: Headers;
};
export type contentFieldsUpdateResponseError = (contentFieldsUpdateResponse401 | contentFieldsUpdateResponse403 | contentFieldsUpdateResponse404 | contentFieldsUpdateResponse422 | contentFieldsUpdateResponse500) & {
  headers: Headers;
};

export type contentFieldsUpdateResponse = (contentFieldsUpdateResponseSuccess | contentFieldsUpdateResponseError)

export const getContentFieldsUpdateUrl = (fieldId: string,) => {




  return `/fields/${fieldId}`
}

/**
 * Меняются название, подсказка, обязательность и настройки. Ключ и вид — нет: у вида отдельная операция с предпросмотром последствий.
 * @summary Изменить поле
 */
export const contentFieldsUpdate = async (fieldId: string,
    updateFieldInputBody: NonReadonly<UpdateFieldInputBody>,
    headers: ContentFieldsUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentFieldsUpdateResponse>(getContentFieldsUpdateUrl(fieldId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFieldInputBody)
  }
);}





export const getContentFieldsUpdateQueryKey = (fieldId: string,
    updateFieldInputBody?: NonReadonly<UpdateFieldInputBody>,) => {
    return [
    'PATCH', `/fields/${fieldId}`, updateFieldInputBody
    ] as const;
    }


export const getContentFieldsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsUpdate>>, TError = ErrorModel>(fieldId: string,
    updateFieldInputBody: NonReadonly<UpdateFieldInputBody>,
    headers: ContentFieldsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsUpdateQueryKey(fieldId,updateFieldInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsUpdate>>> = ({ signal }) => contentFieldsUpdate(fieldId,updateFieldInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fieldId !== null && fieldId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsUpdate>>>
export type ContentFieldsUpdateQueryError = ErrorModel


export function useContentFieldsUpdate<TData = Awaited<ReturnType<typeof contentFieldsUpdate>>, TError = ErrorModel>(
 fieldId: string,
    updateFieldInputBody: NonReadonly<UpdateFieldInputBody>,
    headers: ContentFieldsUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsUpdate>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsUpdate<TData = Awaited<ReturnType<typeof contentFieldsUpdate>>, TError = ErrorModel>(
 fieldId: string,
    updateFieldInputBody: NonReadonly<UpdateFieldInputBody>,
    headers: ContentFieldsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsUpdate>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsUpdate<TData = Awaited<ReturnType<typeof contentFieldsUpdate>>, TError = ErrorModel>(
 fieldId: string,
    updateFieldInputBody: NonReadonly<UpdateFieldInputBody>,
    headers: ContentFieldsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить поле
 */

export function useContentFieldsUpdate<TData = Awaited<ReturnType<typeof contentFieldsUpdate>>, TError = ErrorModel>(
 fieldId: string,
    updateFieldInputBody: NonReadonly<UpdateFieldInputBody>,
    headers: ContentFieldsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsUpdateQueryOptions(fieldId,updateFieldInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsImpactResponse200 = {
  data: ImpactOutputBody
  status: 200
}

export type contentFieldsImpactResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsImpactResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsImpactResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsImpactResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsImpactResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsImpactResponseSuccess = (contentFieldsImpactResponse200) & {
  headers: Headers;
};
export type contentFieldsImpactResponseError = (contentFieldsImpactResponse401 | contentFieldsImpactResponse403 | contentFieldsImpactResponse404 | contentFieldsImpactResponse422 | contentFieldsImpactResponse500) & {
  headers: Headers;
};

export type contentFieldsImpactResponse = (contentFieldsImpactResponseSuccess | contentFieldsImpactResponseError)

export const getContentFieldsImpactUrl = (fieldId: string,) => {




  return `/fields/${fieldId}/impact`
}

/**
 * Прогоняет новые обязательность, проверки и вид редактора по уже заведённым записям, ничего не сохраняя: «стало обязательным — у 120 записей пусто», «до 80 символов — у 12 записей длиннее», «уникальность — 3 повтора».
 * @summary Что будет с данными при новых настройках поля
 */
export const contentFieldsImpact = async (fieldId: string,
    impactInputBody: NonReadonly<ImpactInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsImpactResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentFieldsImpactResponse>(getContentFieldsImpactUrl(fieldId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(impactInputBody)
  }
);}





export const getContentFieldsImpactQueryKey = (fieldId: string,
    impactInputBody?: NonReadonly<ImpactInputBody>,) => {
    return [
    'POST', `/fields/${fieldId}/impact`, impactInputBody
    ] as const;
    }


export const getContentFieldsImpactQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsImpact>>, TError = ErrorModel>(fieldId: string,
    impactInputBody: NonReadonly<ImpactInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsImpact>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsImpactQueryKey(fieldId,impactInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsImpact>>> = ({ signal }) => contentFieldsImpact(fieldId,impactInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fieldId !== null && fieldId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsImpact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsImpactQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsImpact>>>
export type ContentFieldsImpactQueryError = ErrorModel


export function useContentFieldsImpact<TData = Awaited<ReturnType<typeof contentFieldsImpact>>, TError = ErrorModel>(
 fieldId: string,
    impactInputBody: NonReadonly<ImpactInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsImpact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsImpact>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsImpact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsImpact<TData = Awaited<ReturnType<typeof contentFieldsImpact>>, TError = ErrorModel>(
 fieldId: string,
    impactInputBody: NonReadonly<ImpactInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsImpact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsImpact>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsImpact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsImpact<TData = Awaited<ReturnType<typeof contentFieldsImpact>>, TError = ErrorModel>(
 fieldId: string,
    impactInputBody: NonReadonly<ImpactInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsImpact>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Что будет с данными при новых настройках поля
 */

export function useContentFieldsImpact<TData = Awaited<ReturnType<typeof contentFieldsImpact>>, TError = ErrorModel>(
 fieldId: string,
    impactInputBody: NonReadonly<ImpactInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsImpact>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsImpactQueryOptions(fieldId,impactInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsRestoreResponse200 = {
  data: FieldBody
  status: 200
}

export type contentFieldsRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsRestoreResponse409 = {
  data: ErrorModel
  status: 409
}

export type contentFieldsRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsRestoreResponseSuccess = (contentFieldsRestoreResponse200) & {
  headers: Headers;
};
export type contentFieldsRestoreResponseError = (contentFieldsRestoreResponse401 | contentFieldsRestoreResponse403 | contentFieldsRestoreResponse404 | contentFieldsRestoreResponse409 | contentFieldsRestoreResponse422 | contentFieldsRestoreResponse500) & {
  headers: Headers;
};

export type contentFieldsRestoreResponse = (contentFieldsRestoreResponseSuccess | contentFieldsRestoreResponseError)

export const getContentFieldsRestoreUrl = (fieldId: string,) => {




  return `/fields/${fieldId}/restore`
}

/**
 * @summary Вернуть скрытое поле
 */
export const contentFieldsRestore = async (fieldId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsRestoreResponse> => {

  return facetaFetch<contentFieldsRestoreResponse>(getContentFieldsRestoreUrl(fieldId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getContentFieldsRestoreQueryKey = (fieldId: string,) => {
    return [
    'POST', `/fields/${fieldId}/restore`
    ] as const;
    }


export const getContentFieldsRestoreQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsRestore>>, TError = ErrorModel>(fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsRestoreQueryKey(fieldId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsRestore>>> = ({ signal }) => contentFieldsRestore(fieldId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fieldId !== null && fieldId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsRestore>>>
export type ContentFieldsRestoreQueryError = ErrorModel


export function useContentFieldsRestore<TData = Awaited<ReturnType<typeof contentFieldsRestore>>, TError = ErrorModel>(
 fieldId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsRestore>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsRestore<TData = Awaited<ReturnType<typeof contentFieldsRestore>>, TError = ErrorModel>(
 fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsRestore>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsRestore<TData = Awaited<ReturnType<typeof contentFieldsRestore>>, TError = ErrorModel>(
 fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть скрытое поле
 */

export function useContentFieldsRestore<TData = Awaited<ReturnType<typeof contentFieldsRestore>>, TError = ErrorModel>(
 fieldId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsRestoreQueryOptions(fieldId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsChangeTypeResponse200 = {
  data: FieldBody
  status: 200
}

export type contentFieldsChangeTypeResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsChangeTypeResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsChangeTypeResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsChangeTypeResponse409 = {
  data: ErrorModel
  status: 409
}

export type contentFieldsChangeTypeResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsChangeTypeResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsChangeTypeResponseSuccess = (contentFieldsChangeTypeResponse200) & {
  headers: Headers;
};
export type contentFieldsChangeTypeResponseError = (contentFieldsChangeTypeResponse401 | contentFieldsChangeTypeResponse403 | contentFieldsChangeTypeResponse404 | contentFieldsChangeTypeResponse409 | contentFieldsChangeTypeResponse422 | contentFieldsChangeTypeResponse500) & {
  headers: Headers;
};

export type contentFieldsChangeTypeResponse = (contentFieldsChangeTypeResponseSuccess | contentFieldsChangeTypeResponseError)

export const getContentFieldsChangeTypeUrl = (fieldId: string,) => {




  return `/fields/${fieldId}/type`
}

/**
 * Меняет вид и преобразует значения одной транзакцией: поле нового вида со значениями старого — это записи, которые не открываются в редакторе. История версий не трогается, по ней видно, что лежало до преобразования.
 * @summary Сменить вид поля
 */
export const contentFieldsChangeType = async (fieldId: string,
    applyTypeChangeInputBody: NonReadonly<ApplyTypeChangeInputBody>,
    headers: ContentFieldsChangeTypeHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsChangeTypeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentFieldsChangeTypeResponse>(getContentFieldsChangeTypeUrl(fieldId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(applyTypeChangeInputBody)
  }
);}





export const getContentFieldsChangeTypeQueryKey = (fieldId: string,
    applyTypeChangeInputBody?: NonReadonly<ApplyTypeChangeInputBody>,) => {
    return [
    'PUT', `/fields/${fieldId}/type`, applyTypeChangeInputBody
    ] as const;
    }


export const getContentFieldsChangeTypeQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsChangeType>>, TError = ErrorModel>(fieldId: string,
    applyTypeChangeInputBody: NonReadonly<ApplyTypeChangeInputBody>,
    headers: ContentFieldsChangeTypeHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsChangeType>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsChangeTypeQueryKey(fieldId,applyTypeChangeInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsChangeType>>> = ({ signal }) => contentFieldsChangeType(fieldId,applyTypeChangeInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fieldId !== null && fieldId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsChangeType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsChangeTypeQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsChangeType>>>
export type ContentFieldsChangeTypeQueryError = ErrorModel


export function useContentFieldsChangeType<TData = Awaited<ReturnType<typeof contentFieldsChangeType>>, TError = ErrorModel>(
 fieldId: string,
    applyTypeChangeInputBody: NonReadonly<ApplyTypeChangeInputBody>,
    headers: ContentFieldsChangeTypeHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsChangeType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsChangeType>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsChangeType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsChangeType<TData = Awaited<ReturnType<typeof contentFieldsChangeType>>, TError = ErrorModel>(
 fieldId: string,
    applyTypeChangeInputBody: NonReadonly<ApplyTypeChangeInputBody>,
    headers: ContentFieldsChangeTypeHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsChangeType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsChangeType>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsChangeType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsChangeType<TData = Awaited<ReturnType<typeof contentFieldsChangeType>>, TError = ErrorModel>(
 fieldId: string,
    applyTypeChangeInputBody: NonReadonly<ApplyTypeChangeInputBody>,
    headers: ContentFieldsChangeTypeHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsChangeType>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сменить вид поля
 */

export function useContentFieldsChangeType<TData = Awaited<ReturnType<typeof contentFieldsChangeType>>, TError = ErrorModel>(
 fieldId: string,
    applyTypeChangeInputBody: NonReadonly<ApplyTypeChangeInputBody>,
    headers: ContentFieldsChangeTypeHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsChangeType>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsChangeTypeQueryOptions(fieldId,applyTypeChangeInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentFieldsTypeChangePreviewResponse200 = {
  data: TypeChangeOutputBody
  status: 200
}

export type contentFieldsTypeChangePreviewResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentFieldsTypeChangePreviewResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentFieldsTypeChangePreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentFieldsTypeChangePreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentFieldsTypeChangePreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentFieldsTypeChangePreviewResponseSuccess = (contentFieldsTypeChangePreviewResponse200) & {
  headers: Headers;
};
export type contentFieldsTypeChangePreviewResponseError = (contentFieldsTypeChangePreviewResponse401 | contentFieldsTypeChangePreviewResponse403 | contentFieldsTypeChangePreviewResponse404 | contentFieldsTypeChangePreviewResponse422 | contentFieldsTypeChangePreviewResponse500) & {
  headers: Headers;
};

export type contentFieldsTypeChangePreviewResponse = (contentFieldsTypeChangePreviewResponseSuccess | contentFieldsTypeChangePreviewResponseError)

export const getContentFieldsTypeChangePreviewUrl = (fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/fields/${fieldId}/type-change?${stringifiedParams}` : `/fields/${fieldId}/type-change`
}

/**
 * Считает, сколько записей затронуто и у скольких значение не удастся перенести. Показывается до нажатия, а не после: смена вида — обычный ход работы, но часть переходов теряет данные, и человек должен знать заранее.
 * @summary Что будет при смене вида поля
 */
export const contentFieldsTypeChangePreview = async (fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams, options?: Parameters<typeof facetaFetch>[1]): Promise<contentFieldsTypeChangePreviewResponse> => {

  return facetaFetch<contentFieldsTypeChangePreviewResponse>(getContentFieldsTypeChangePreviewUrl(fieldId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentFieldsTypeChangePreviewQueryKey = (fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams,) => {
    return [
    `/fields/${fieldId}/type-change`, ...(params ? [params] : [])
    ] as const;
    }


export const getContentFieldsTypeChangePreviewQueryOptions = <TData = Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError = ErrorModel>(fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentFieldsTypeChangePreviewQueryKey(fieldId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>> = ({ signal }) => contentFieldsTypeChangePreview(fieldId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fieldId !== null && fieldId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentFieldsTypeChangePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>>
export type ContentFieldsTypeChangePreviewQueryError = ErrorModel


export function useContentFieldsTypeChangePreview<TData = Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError = ErrorModel>(
 fieldId: string,
    params: undefined |  ContentFieldsTypeChangePreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsTypeChangePreview<TData = Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError = ErrorModel>(
 fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>,
          TError,
          Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentFieldsTypeChangePreview<TData = Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError = ErrorModel>(
 fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Что будет при смене вида поля
 */

export function useContentFieldsTypeChangePreview<TData = Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError = ErrorModel>(
 fieldId: string,
    params?: ContentFieldsTypeChangePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentFieldsTypeChangePreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentFieldsTypeChangePreviewQueryOptions(fieldId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentMenuIconsResponse200 = {
  data: MenuIconsOutputBody
  status: 200
}

export type contentMenuIconsResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentMenuIconsResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentMenuIconsResponseSuccess = (contentMenuIconsResponse200) & {
  headers: Headers;
};
export type contentMenuIconsResponseError = (contentMenuIconsResponse401 | contentMenuIconsResponse500) & {
  headers: Headers;
};

export type contentMenuIconsResponse = (contentMenuIconsResponseSuccess | contentMenuIconsResponseError)

export const getContentMenuIconsUrl = () => {




  return `/menu-icons`
}

/**
 * @summary Иконки для меню сайта
 */
export const contentMenuIcons = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<contentMenuIconsResponse> => {

  return facetaFetch<contentMenuIconsResponse>(getContentMenuIconsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentMenuIconsQueryKey = () => {
    return [
    `/menu-icons`
    ] as const;
    }


export const getContentMenuIconsQueryOptions = <TData = Awaited<ReturnType<typeof contentMenuIcons>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentMenuIcons>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentMenuIconsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentMenuIcons>>> = ({ signal }) => contentMenuIcons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentMenuIcons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentMenuIconsQueryResult = NonNullable<Awaited<ReturnType<typeof contentMenuIcons>>>
export type ContentMenuIconsQueryError = ErrorModel


export function useContentMenuIcons<TData = Awaited<ReturnType<typeof contentMenuIcons>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentMenuIcons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentMenuIcons>>,
          TError,
          Awaited<ReturnType<typeof contentMenuIcons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentMenuIcons<TData = Awaited<ReturnType<typeof contentMenuIcons>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentMenuIcons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentMenuIcons>>,
          TError,
          Awaited<ReturnType<typeof contentMenuIcons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentMenuIcons<TData = Awaited<ReturnType<typeof contentMenuIcons>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentMenuIcons>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Иконки для меню сайта
 */

export function useContentMenuIcons<TData = Awaited<ReturnType<typeof contentMenuIcons>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentMenuIcons>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentMenuIconsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type schemaTransferRollbackResponse200 = {
  data: TransferBody
  status: 200
}

export type schemaTransferRollbackResponse401 = {
  data: ErrorModel
  status: 401
}

export type schemaTransferRollbackResponse403 = {
  data: ErrorModel
  status: 403
}

export type schemaTransferRollbackResponse404 = {
  data: ErrorModel
  status: 404
}

export type schemaTransferRollbackResponse409 = {
  data: ErrorModel
  status: 409
}

export type schemaTransferRollbackResponse422 = {
  data: ErrorModel
  status: 422
}

export type schemaTransferRollbackResponse500 = {
  data: ErrorModel
  status: 500
}

export type schemaTransferRollbackResponseSuccess = (schemaTransferRollbackResponse200) & {
  headers: Headers;
};
export type schemaTransferRollbackResponseError = (schemaTransferRollbackResponse401 | schemaTransferRollbackResponse403 | schemaTransferRollbackResponse404 | schemaTransferRollbackResponse409 | schemaTransferRollbackResponse422 | schemaTransferRollbackResponse500) & {
  headers: Headers;
};

export type schemaTransferRollbackResponse = (schemaTransferRollbackResponseSuccess | schemaTransferRollbackResponseError)

export const getSchemaTransferRollbackUrl = (transferId: string,) => {




  return `/schema-transfers/${transferId}/rollback`
}

/**
 * Возвращает схему получателя к снимку до переноса и прежние значения записей — там, где их с тех пор не меняли. Типы и поля, заведённые переносом, уходят в корзину и скрываются, а не удаляются. Откатить можно только последний перенос в окружение.
 * @summary Откатить перенос
 */
export const schemaTransferRollback = async (transferId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<schemaTransferRollbackResponse> => {

  return facetaFetch<schemaTransferRollbackResponse>(getSchemaTransferRollbackUrl(transferId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSchemaTransferRollbackQueryKey = (transferId: string,) => {
    return [
    'POST', `/schema-transfers/${transferId}/rollback`
    ] as const;
    }


export const getSchemaTransferRollbackQueryOptions = <TData = Awaited<ReturnType<typeof schemaTransferRollback>>, TError = ErrorModel>(transferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferRollback>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchemaTransferRollbackQueryKey(transferId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schemaTransferRollback>>> = ({ signal }) => schemaTransferRollback(transferId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: transferId !== null && transferId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schemaTransferRollback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchemaTransferRollbackQueryResult = NonNullable<Awaited<ReturnType<typeof schemaTransferRollback>>>
export type SchemaTransferRollbackQueryError = ErrorModel


export function useSchemaTransferRollback<TData = Awaited<ReturnType<typeof schemaTransferRollback>>, TError = ErrorModel>(
 transferId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferRollback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransferRollback>>,
          TError,
          Awaited<ReturnType<typeof schemaTransferRollback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransferRollback<TData = Awaited<ReturnType<typeof schemaTransferRollback>>, TError = ErrorModel>(
 transferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferRollback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransferRollback>>,
          TError,
          Awaited<ReturnType<typeof schemaTransferRollback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransferRollback<TData = Awaited<ReturnType<typeof schemaTransferRollback>>, TError = ErrorModel>(
 transferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferRollback>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Откатить перенос
 */

export function useSchemaTransferRollback<TData = Awaited<ReturnType<typeof schemaTransferRollback>>, TError = ErrorModel>(
 transferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferRollback>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchemaTransferRollbackQueryOptions(transferId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type devRefreshPreviewResponse200 = {
  data: RefreshBody
  status: 200
}

export type devRefreshPreviewResponse401 = {
  data: ErrorModel
  status: 401
}

export type devRefreshPreviewResponse403 = {
  data: ErrorModel
  status: 403
}

export type devRefreshPreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type devRefreshPreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type devRefreshPreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type devRefreshPreviewResponseSuccess = (devRefreshPreviewResponse200) & {
  headers: Headers;
};
export type devRefreshPreviewResponseError = (devRefreshPreviewResponse401 | devRefreshPreviewResponse403 | devRefreshPreviewResponse404 | devRefreshPreviewResponse422 | devRefreshPreviewResponse500) & {
  headers: Headers;
};

export type devRefreshPreviewResponse = (devRefreshPreviewResponseSuccess | devRefreshPreviewResponseError)

export const getDevRefreshPreviewUrl = (id: string,) => {




  return `/sites/${id}/dev-refresh`
}

/**
 * @summary Что сделает обновление Development данными Production
 */
export const devRefreshPreview = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<devRefreshPreviewResponse> => {

  return facetaFetch<devRefreshPreviewResponse>(getDevRefreshPreviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDevRefreshPreviewQueryKey = (id: string,) => {
    return [
    `/sites/${id}/dev-refresh`
    ] as const;
    }


export const getDevRefreshPreviewQueryOptions = <TData = Awaited<ReturnType<typeof devRefreshPreview>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevRefreshPreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devRefreshPreview>>> = ({ signal }) => devRefreshPreview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devRefreshPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevRefreshPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof devRefreshPreview>>>
export type DevRefreshPreviewQueryError = ErrorModel


export function useDevRefreshPreview<TData = Awaited<ReturnType<typeof devRefreshPreview>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devRefreshPreview>>,
          TError,
          Awaited<ReturnType<typeof devRefreshPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevRefreshPreview<TData = Awaited<ReturnType<typeof devRefreshPreview>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devRefreshPreview>>,
          TError,
          Awaited<ReturnType<typeof devRefreshPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevRefreshPreview<TData = Awaited<ReturnType<typeof devRefreshPreview>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Что сделает обновление Development данными Production
 */

export function useDevRefreshPreview<TData = Awaited<ReturnType<typeof devRefreshPreview>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevRefreshPreviewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type devRefreshApplyResponse200 = {
  data: RefreshBody
  status: 200
}

export type devRefreshApplyResponse401 = {
  data: ErrorModel
  status: 401
}

export type devRefreshApplyResponse403 = {
  data: ErrorModel
  status: 403
}

export type devRefreshApplyResponse404 = {
  data: ErrorModel
  status: 404
}

export type devRefreshApplyResponse409 = {
  data: ErrorModel
  status: 409
}

export type devRefreshApplyResponse422 = {
  data: ErrorModel
  status: 422
}

export type devRefreshApplyResponse500 = {
  data: ErrorModel
  status: 500
}

export type devRefreshApplyResponseSuccess = (devRefreshApplyResponse200) & {
  headers: Headers;
};
export type devRefreshApplyResponseError = (devRefreshApplyResponse401 | devRefreshApplyResponse403 | devRefreshApplyResponse404 | devRefreshApplyResponse409 | devRefreshApplyResponse422 | devRefreshApplyResponse500) & {
  headers: Headers;
};

export type devRefreshApplyResponse = (devRefreshApplyResponseSuccess | devRefreshApplyResponseError)

export const getDevRefreshApplyUrl = (id: string,) => {




  return `/sites/${id}/dev-refresh`
}

/**
 * Схема, файлы и записи Production переносятся на Development; записи Development без пары на Production уходят в корзину. Нужно согласие.
 * @summary Обновить Development данными Production
 */
export const devRefreshApply = async (id: string,
    refreshApplyInputBody: NonReadonly<RefreshApplyInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<devRefreshApplyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<devRefreshApplyResponse>(getDevRefreshApplyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(refreshApplyInputBody)
  }
);}





export const getDevRefreshApplyQueryKey = (id: string,
    refreshApplyInputBody?: NonReadonly<RefreshApplyInputBody>,) => {
    return [
    'POST', `/sites/${id}/dev-refresh`, refreshApplyInputBody
    ] as const;
    }


export const getDevRefreshApplyQueryOptions = <TData = Awaited<ReturnType<typeof devRefreshApply>>, TError = ErrorModel>(id: string,
    refreshApplyInputBody: NonReadonly<RefreshApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevRefreshApplyQueryKey(id,refreshApplyInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devRefreshApply>>> = ({ signal }) => devRefreshApply(id,refreshApplyInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devRefreshApply>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevRefreshApplyQueryResult = NonNullable<Awaited<ReturnType<typeof devRefreshApply>>>
export type DevRefreshApplyQueryError = ErrorModel


export function useDevRefreshApply<TData = Awaited<ReturnType<typeof devRefreshApply>>, TError = ErrorModel>(
 id: string,
    refreshApplyInputBody: NonReadonly<RefreshApplyInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshApply>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devRefreshApply>>,
          TError,
          Awaited<ReturnType<typeof devRefreshApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevRefreshApply<TData = Awaited<ReturnType<typeof devRefreshApply>>, TError = ErrorModel>(
 id: string,
    refreshApplyInputBody: NonReadonly<RefreshApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshApply>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devRefreshApply>>,
          TError,
          Awaited<ReturnType<typeof devRefreshApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevRefreshApply<TData = Awaited<ReturnType<typeof devRefreshApply>>, TError = ErrorModel>(
 id: string,
    refreshApplyInputBody: NonReadonly<RefreshApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Обновить Development данными Production
 */

export function useDevRefreshApply<TData = Awaited<ReturnType<typeof devRefreshApply>>, TError = ErrorModel>(
 id: string,
    refreshApplyInputBody: NonReadonly<RefreshApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devRefreshApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevRefreshApplyQueryOptions(id,refreshApplyInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentBlockTypesResponse200 = {
  data: BlockTypesOutputBody
  status: 200
}

export type contentBlockTypesResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentBlockTypesResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentBlockTypesResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentBlockTypesResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentBlockTypesResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentBlockTypesResponseSuccess = (contentBlockTypesResponse200) & {
  headers: Headers;
};
export type contentBlockTypesResponseError = (contentBlockTypesResponse401 | contentBlockTypesResponse403 | contentBlockTypesResponse404 | contentBlockTypesResponse422 | contentBlockTypesResponse500) & {
  headers: Headers;
};

export type contentBlockTypesResponse = (contentBlockTypesResponseSuccess | contentBlockTypesResponseError)

export const getContentBlockTypesUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/block-types`
}

/**
 * Встроенные блоки и свои блоки окружения вместе с их полями. Отдаётся сервером: поля блока — те же, что у записи, и второго их описания на клиенте быть не должно. Блоки из корзины не предлагаются.
 * @summary Блоки для поля «блоки»
 */
export const contentBlockTypes = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<contentBlockTypesResponse> => {

  return facetaFetch<contentBlockTypesResponse>(getContentBlockTypesUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentBlockTypesQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/block-types`
    ] as const;
    }


export const getContentBlockTypesQueryOptions = <TData = Awaited<ReturnType<typeof contentBlockTypes>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentBlockTypes>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentBlockTypesQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentBlockTypes>>> = ({ signal }) => contentBlockTypes(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentBlockTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentBlockTypesQueryResult = NonNullable<Awaited<ReturnType<typeof contentBlockTypes>>>
export type ContentBlockTypesQueryError = ErrorModel


export function useContentBlockTypes<TData = Awaited<ReturnType<typeof contentBlockTypes>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentBlockTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentBlockTypes>>,
          TError,
          Awaited<ReturnType<typeof contentBlockTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentBlockTypes<TData = Awaited<ReturnType<typeof contentBlockTypes>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentBlockTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentBlockTypes>>,
          TError,
          Awaited<ReturnType<typeof contentBlockTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentBlockTypes<TData = Awaited<ReturnType<typeof contentBlockTypes>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentBlockTypes>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Блоки для поля «блоки»
 */

export function useContentBlockTypes<TData = Awaited<ReturnType<typeof contentBlockTypes>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentBlockTypes>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentBlockTypesQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesListResponse200 = {
  data: TypesOutputBody
  status: 200
}

export type contentTypesListResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesListResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesListResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesListResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesListResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesListResponseSuccess = (contentTypesListResponse200) & {
  headers: Headers;
};
export type contentTypesListResponseError = (contentTypesListResponse401 | contentTypesListResponse403 | contentTypesListResponse404 | contentTypesListResponse422 | contentTypesListResponse500) & {
  headers: Headers;
};

export type contentTypesListResponse = (contentTypesListResponseSuccess | contentTypesListResponseError)

export const getContentTypesListUrl = (id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/content-types?${stringifiedParams}` : `/sites/${id}/environments/${kind}/content-types`
}

/**
 * У каждого окружения своя схема: дев — место, где её пробуют, прод получает её осознанно. Страниц нет: типов единицы, это структура, а не данные.
 * @summary Типы контента окружения
 */
export const contentTypesList = async (id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesListResponse> => {

  return facetaFetch<contentTypesListResponse>(getContentTypesListUrl(id,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContentTypesListQueryKey = (id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams,) => {
    return [
    `/sites/${id}/environments/${kind}/content-types`, ...(params ? [params] : [])
    ] as const;
    }


export const getContentTypesListQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesListQueryKey(id,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesList>>> = ({ signal }) => contentTypesList(id,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesList>>>
export type ContentTypesListQueryError = ErrorModel


export function useContentTypesList<TData = Awaited<ReturnType<typeof contentTypesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params: undefined |  ContentTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesList>>,
          TError,
          Awaited<ReturnType<typeof contentTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesList<TData = Awaited<ReturnType<typeof contentTypesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesList>>,
          TError,
          Awaited<ReturnType<typeof contentTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesList<TData = Awaited<ReturnType<typeof contentTypesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Типы контента окружения
 */

export function useContentTypesList<TData = Awaited<ReturnType<typeof contentTypesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: ContentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesListQueryOptions(id,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesCreateResponse201 = {
  data: TypeBody
  status: 201
}

export type contentTypesCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type contentTypesCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesCreateResponseSuccess = (contentTypesCreateResponse201) & {
  headers: Headers;
};
export type contentTypesCreateResponseError = (contentTypesCreateResponse401 | contentTypesCreateResponse403 | contentTypesCreateResponse404 | contentTypesCreateResponse409 | contentTypesCreateResponse422 | contentTypesCreateResponse500) & {
  headers: Headers;
};

export type contentTypesCreateResponse = (contentTypesCreateResponseSuccess | contentTypesCreateResponseError)

export const getContentTypesCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/content-types`
}

/**
 * Вид типа — список записей или одиночная запись — выбирается один раз и потом не меняется: у одиночного типа ровно одна запись, и превращение его в список оставило бы вопрос, что с ней делать.
 * @summary Завести тип контента
 */
export const contentTypesCreate = async (id: string,
    kind: 'production' | 'development',
    createTypeInputBody: NonReadonly<CreateTypeInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentTypesCreateResponse>(getContentTypesCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTypeInputBody)
  }
);}





export const getContentTypesCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    createTypeInputBody?: NonReadonly<CreateTypeInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/content-types`, createTypeInputBody
    ] as const;
    }


export const getContentTypesCreateQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    createTypeInputBody: NonReadonly<CreateTypeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesCreateQueryKey(id,kind,createTypeInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesCreate>>> = ({ signal }) => contentTypesCreate(id,kind,createTypeInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesCreate>>>
export type ContentTypesCreateQueryError = ErrorModel


export function useContentTypesCreate<TData = Awaited<ReturnType<typeof contentTypesCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createTypeInputBody: NonReadonly<CreateTypeInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesCreate>>,
          TError,
          Awaited<ReturnType<typeof contentTypesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesCreate<TData = Awaited<ReturnType<typeof contentTypesCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createTypeInputBody: NonReadonly<CreateTypeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesCreate>>,
          TError,
          Awaited<ReturnType<typeof contentTypesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesCreate<TData = Awaited<ReturnType<typeof contentTypesCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createTypeInputBody: NonReadonly<CreateTypeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести тип контента
 */

export function useContentTypesCreate<TData = Awaited<ReturnType<typeof contentTypesCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createTypeInputBody: NonReadonly<CreateTypeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesCreateQueryOptions(id,kind,createTypeInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type contentTypesReorderResponse204 = {
  data: void
  status: 204
}

export type contentTypesReorderResponse401 = {
  data: ErrorModel
  status: 401
}

export type contentTypesReorderResponse403 = {
  data: ErrorModel
  status: 403
}

export type contentTypesReorderResponse404 = {
  data: ErrorModel
  status: 404
}

export type contentTypesReorderResponse422 = {
  data: ErrorModel
  status: 422
}

export type contentTypesReorderResponse500 = {
  data: ErrorModel
  status: 500
}

export type contentTypesReorderResponseSuccess = (contentTypesReorderResponse204) & {
  headers: Headers;
};
export type contentTypesReorderResponseError = (contentTypesReorderResponse401 | contentTypesReorderResponse403 | contentTypesReorderResponse404 | contentTypesReorderResponse422 | contentTypesReorderResponse500) & {
  headers: Headers;
};

export type contentTypesReorderResponse = (contentTypesReorderResponseSuccess | contentTypesReorderResponseError)

export const getContentTypesReorderUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/content-types/order`
}

/**
 * Список целиком, а не «сдвинуть одно»: два человека, переставляющие одновременно, получат порядок одного из них, а не смесь.
 * @summary Порядок типов — он же порядок в меню сайта
 */
export const contentTypesReorder = async (id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody: NonReadonly<ReorderTypesInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<contentTypesReorderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<contentTypesReorderResponse>(getContentTypesReorderUrl(id,kind),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderTypesInputBody)
  }
);}





export const getContentTypesReorderQueryKey = (id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody?: NonReadonly<ReorderTypesInputBody>,) => {
    return [
    'PUT', `/sites/${id}/environments/${kind}/content-types/order`, reorderTypesInputBody
    ] as const;
    }


export const getContentTypesReorderQueryOptions = <TData = Awaited<ReturnType<typeof contentTypesReorder>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody: NonReadonly<ReorderTypesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContentTypesReorderQueryKey(id,kind,reorderTypesInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contentTypesReorder>>> = ({ signal }) => contentTypesReorder(id,kind,reorderTypesInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contentTypesReorder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContentTypesReorderQueryResult = NonNullable<Awaited<ReturnType<typeof contentTypesReorder>>>
export type ContentTypesReorderQueryError = ErrorModel


export function useContentTypesReorder<TData = Awaited<ReturnType<typeof contentTypesReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody: NonReadonly<ReorderTypesInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesReorder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesReorder>>,
          TError,
          Awaited<ReturnType<typeof contentTypesReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesReorder<TData = Awaited<ReturnType<typeof contentTypesReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody: NonReadonly<ReorderTypesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesReorder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contentTypesReorder>>,
          TError,
          Awaited<ReturnType<typeof contentTypesReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContentTypesReorder<TData = Awaited<ReturnType<typeof contentTypesReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody: NonReadonly<ReorderTypesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Порядок типов — он же порядок в меню сайта
 */

export function useContentTypesReorder<TData = Awaited<ReturnType<typeof contentTypesReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderTypesInputBody: NonReadonly<ReorderTypesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contentTypesReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContentTypesReorderQueryOptions(id,kind,reorderTypesInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type schemaExportResponse200 = {
  data: SchemaFile
  status: 200
}

export type schemaExportResponse401 = {
  data: ErrorModel
  status: 401
}

export type schemaExportResponse403 = {
  data: ErrorModel
  status: 403
}

export type schemaExportResponse404 = {
  data: ErrorModel
  status: 404
}

export type schemaExportResponse422 = {
  data: ErrorModel
  status: 422
}

export type schemaExportResponse500 = {
  data: ErrorModel
  status: 500
}

export type schemaExportResponseSuccess = (schemaExportResponse200) & {
  headers: Headers;
};
export type schemaExportResponseError = (schemaExportResponse401 | schemaExportResponse403 | schemaExportResponse404 | schemaExportResponse422 | schemaExportResponse500) & {
  headers: Headers;
};

export type schemaExportResponse = (schemaExportResponseSuccess | schemaExportResponseError)

export const getSchemaExportUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/schema/export`
}

/**
 * Модели, компоненты, поля, статусы и правила — без записей и id: файл годится для любого сайта.
 * @summary Выгрузить схему JSON
 */
export const schemaExport = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<schemaExportResponse> => {

  return facetaFetch<schemaExportResponse>(getSchemaExportUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSchemaExportQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/schema/export`
    ] as const;
    }


export const getSchemaExportQueryOptions = <TData = Awaited<ReturnType<typeof schemaExport>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaExport>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchemaExportQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schemaExport>>> = ({ signal }) => schemaExport(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schemaExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchemaExportQueryResult = NonNullable<Awaited<ReturnType<typeof schemaExport>>>
export type SchemaExportQueryError = ErrorModel


export function useSchemaExport<TData = Awaited<ReturnType<typeof schemaExport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaExport>>,
          TError,
          Awaited<ReturnType<typeof schemaExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaExport<TData = Awaited<ReturnType<typeof schemaExport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaExport>>,
          TError,
          Awaited<ReturnType<typeof schemaExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaExport<TData = Awaited<ReturnType<typeof schemaExport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaExport>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Выгрузить схему JSON
 */

export function useSchemaExport<TData = Awaited<ReturnType<typeof schemaExport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaExport>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchemaExportQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type schemaImportResponse200 = {
  data: ImportOutputBody
  status: 200
}

export type schemaImportResponse401 = {
  data: ErrorModel
  status: 401
}

export type schemaImportResponse403 = {
  data: ErrorModel
  status: 403
}

export type schemaImportResponse404 = {
  data: ErrorModel
  status: 404
}

export type schemaImportResponse422 = {
  data: ErrorModel
  status: 422
}

export type schemaImportResponse500 = {
  data: ErrorModel
  status: 500
}

export type schemaImportResponseSuccess = (schemaImportResponse200) & {
  headers: Headers;
};
export type schemaImportResponseError = (schemaImportResponse401 | schemaImportResponse403 | schemaImportResponse404 | schemaImportResponse422 | schemaImportResponse500) & {
  headers: Headers;
};

export type schemaImportResponse = (schemaImportResponseSuccess | schemaImportResponseError)

export const getSchemaImportUrl = (id: string,
    kind: 'production' | 'development',
    params?: SchemaImportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/schema/import?${stringifiedParams}` : `/sites/${id}/environments/${kind}/schema/import`
}

/**
 * Только добавляет: модели с занятыми короткими именами пропускаются. Поля проверяются, как при создании; не прошла модель — заведённое ею убирается. dry_run — только посмотреть.
 * @summary Загрузить схему JSON
 */
export const schemaImport = async (id: string,
    kind: 'production' | 'development',
    schemaFile: NonReadonly<SchemaFile>,
    params?: SchemaImportParams, options?: Parameters<typeof facetaFetch>[1]): Promise<schemaImportResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<schemaImportResponse>(getSchemaImportUrl(id,kind,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(schemaFile)
  }
);}





export const getSchemaImportQueryKey = (id: string,
    kind: 'production' | 'development',
    schemaFile?: NonReadonly<SchemaFile>,
    params?: SchemaImportParams,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/schema/import`, ...(params ? [params] : []), schemaFile
    ] as const;
    }


export const getSchemaImportQueryOptions = <TData = Awaited<ReturnType<typeof schemaImport>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    schemaFile: NonReadonly<SchemaFile>,
    params?: SchemaImportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaImport>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchemaImportQueryKey(id,kind,schemaFile,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schemaImport>>> = ({ signal }) => schemaImport(id,kind,schemaFile,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schemaImport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchemaImportQueryResult = NonNullable<Awaited<ReturnType<typeof schemaImport>>>
export type SchemaImportQueryError = ErrorModel


export function useSchemaImport<TData = Awaited<ReturnType<typeof schemaImport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    schemaFile: NonReadonly<SchemaFile>,
    params: undefined |  SchemaImportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaImport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaImport>>,
          TError,
          Awaited<ReturnType<typeof schemaImport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaImport<TData = Awaited<ReturnType<typeof schemaImport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    schemaFile: NonReadonly<SchemaFile>,
    params?: SchemaImportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaImport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaImport>>,
          TError,
          Awaited<ReturnType<typeof schemaImport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaImport<TData = Awaited<ReturnType<typeof schemaImport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    schemaFile: NonReadonly<SchemaFile>,
    params?: SchemaImportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaImport>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Загрузить схему JSON
 */

export function useSchemaImport<TData = Awaited<ReturnType<typeof schemaImport>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    schemaFile: NonReadonly<SchemaFile>,
    params?: SchemaImportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaImport>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchemaImportQueryOptions(id,kind,schemaFile,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type templatesListResponse200 = {
  data: TemplatesOutputBody
  status: 200
}

export type templatesListResponse401 = {
  data: ErrorModel
  status: 401
}

export type templatesListResponse403 = {
  data: ErrorModel
  status: 403
}

export type templatesListResponse404 = {
  data: ErrorModel
  status: 404
}

export type templatesListResponse422 = {
  data: ErrorModel
  status: 422
}

export type templatesListResponse500 = {
  data: ErrorModel
  status: 500
}

export type templatesListResponseSuccess = (templatesListResponse200) & {
  headers: Headers;
};
export type templatesListResponseError = (templatesListResponse401 | templatesListResponse403 | templatesListResponse404 | templatesListResponse422 | templatesListResponse500) & {
  headers: Headers;
};

export type templatesListResponse = (templatesListResponseSuccess | templatesListResponseError)

export const getTemplatesListUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/templates`
}

/**
 * @summary Шаблоны моделей
 */
export const templatesList = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<templatesListResponse> => {

  return facetaFetch<templatesListResponse>(getTemplatesListUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTemplatesListQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/templates`
    ] as const;
    }


export const getTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof templatesList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesListQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesList>>> = ({ signal }) => templatesList(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof templatesList>>>
export type TemplatesListQueryError = ErrorModel


export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesList>>,
          TError,
          Awaited<ReturnType<typeof templatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesList>>,
          TError,
          Awaited<ReturnType<typeof templatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Шаблоны моделей
 */

export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesListQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type templatesApplyResponse201 = {
  data: TypeBody
  status: 201
}

export type templatesApplyResponse401 = {
  data: ErrorModel
  status: 401
}

export type templatesApplyResponse403 = {
  data: ErrorModel
  status: 403
}

export type templatesApplyResponse404 = {
  data: ErrorModel
  status: 404
}

export type templatesApplyResponse409 = {
  data: ErrorModel
  status: 409
}

export type templatesApplyResponse422 = {
  data: ErrorModel
  status: 422
}

export type templatesApplyResponse500 = {
  data: ErrorModel
  status: 500
}

export type templatesApplyResponseSuccess = (templatesApplyResponse201) & {
  headers: Headers;
};
export type templatesApplyResponseError = (templatesApplyResponse401 | templatesApplyResponse403 | templatesApplyResponse404 | templatesApplyResponse409 | templatesApplyResponse422 | templatesApplyResponse500) & {
  headers: Headers;
};

export type templatesApplyResponse = (templatesApplyResponseSuccess | templatesApplyResponseError)

export const getTemplatesApplyUrl = (id: string,
    kind: 'production' | 'development',
    template: string,) => {




  return `/sites/${id}/environments/${kind}/templates/${template}`
}

/**
 * Модели с полями, правилами доступа, статусами и правилами сервера — как обычные, их можно менять. Отдаёт главную. Короткое имя занято — 409, ничего не заводится.
 * @summary Завести модели по шаблону
 */
export const templatesApply = async (id: string,
    kind: 'production' | 'development',
    template: string, options?: Parameters<typeof facetaFetch>[1]): Promise<templatesApplyResponse> => {

  return facetaFetch<templatesApplyResponse>(getTemplatesApplyUrl(id,kind,template),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTemplatesApplyQueryKey = (id: string,
    kind: 'production' | 'development',
    template: string,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/templates/${template}`
    ] as const;
    }


export const getTemplatesApplyQueryOptions = <TData = Awaited<ReturnType<typeof templatesApply>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    template: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesApplyQueryKey(id,kind,template);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesApply>>> = ({ signal }) => templatesApply(id,kind,template, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined && template !== null && template !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesApply>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesApplyQueryResult = NonNullable<Awaited<ReturnType<typeof templatesApply>>>
export type TemplatesApplyQueryError = ErrorModel


export function useTemplatesApply<TData = Awaited<ReturnType<typeof templatesApply>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    template: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesApply>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesApply>>,
          TError,
          Awaited<ReturnType<typeof templatesApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesApply<TData = Awaited<ReturnType<typeof templatesApply>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    template: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesApply>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesApply>>,
          TError,
          Awaited<ReturnType<typeof templatesApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesApply<TData = Awaited<ReturnType<typeof templatesApply>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    template: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести модели по шаблону
 */

export function useTemplatesApply<TData = Awaited<ReturnType<typeof templatesApply>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    template: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesApplyQueryOptions(id,kind,template,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordTransferApplyResponse201 = {
  data: RecordTransferOutputBody
  status: 201
}

export type recordTransferApplyResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordTransferApplyResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordTransferApplyResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordTransferApplyResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordTransferApplyResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordTransferApplyResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordTransferApplyResponseSuccess = (recordTransferApplyResponse201) & {
  headers: Headers;
};
export type recordTransferApplyResponseError = (recordTransferApplyResponse401 | recordTransferApplyResponse403 | recordTransferApplyResponse404 | recordTransferApplyResponse409 | recordTransferApplyResponse422 | recordTransferApplyResponse500) & {
  headers: Headers;
};

export type recordTransferApplyResponse = (recordTransferApplyResponseSuccess | recordTransferApplyResponseError)

export const getRecordTransferApplyUrl = (id: string,) => {




  return `/sites/${id}/record-transfer`
}

/**
 * Одной транзакцией. Копия на Production — черновик; повторный перенос обновляет её черновик, опубликованное не трогает. Ссылки на файлы и записи переписываются на копии; файлы копируются записью о том же файле.
 * @summary Перенести записи на Production
 */
export const recordTransferApply = async (id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordTransferApplyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordTransferApplyResponse>(getRecordTransferApplyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recordTransferInputBody)
  }
);}





export const getRecordTransferApplyQueryKey = (id: string,
    recordTransferInputBody?: NonReadonly<RecordTransferInputBody>,) => {
    return [
    'POST', `/sites/${id}/record-transfer`, recordTransferInputBody
    ] as const;
    }


export const getRecordTransferApplyQueryOptions = <TData = Awaited<ReturnType<typeof recordTransferApply>>, TError = ErrorModel>(id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordTransferApplyQueryKey(id,recordTransferInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordTransferApply>>> = ({ signal }) => recordTransferApply(id,recordTransferInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordTransferApply>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordTransferApplyQueryResult = NonNullable<Awaited<ReturnType<typeof recordTransferApply>>>
export type RecordTransferApplyQueryError = ErrorModel


export function useRecordTransferApply<TData = Awaited<ReturnType<typeof recordTransferApply>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferApply>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordTransferApply>>,
          TError,
          Awaited<ReturnType<typeof recordTransferApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordTransferApply<TData = Awaited<ReturnType<typeof recordTransferApply>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferApply>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordTransferApply>>,
          TError,
          Awaited<ReturnType<typeof recordTransferApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordTransferApply<TData = Awaited<ReturnType<typeof recordTransferApply>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Перенести записи на Production
 */

export function useRecordTransferApply<TData = Awaited<ReturnType<typeof recordTransferApply>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordTransferApplyQueryOptions(id,recordTransferInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordTransferPreviewResponse200 = {
  data: RecordTransferPreviewOutputBody
  status: 200
}

export type recordTransferPreviewResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordTransferPreviewResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordTransferPreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordTransferPreviewResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordTransferPreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordTransferPreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordTransferPreviewResponseSuccess = (recordTransferPreviewResponse200) & {
  headers: Headers;
};
export type recordTransferPreviewResponseError = (recordTransferPreviewResponse401 | recordTransferPreviewResponse403 | recordTransferPreviewResponse404 | recordTransferPreviewResponse409 | recordTransferPreviewResponse422 | recordTransferPreviewResponse500) & {
  headers: Headers;
};

export type recordTransferPreviewResponse = (recordTransferPreviewResponseSuccess | recordTransferPreviewResponseError)

export const getRecordTransferPreviewUrl = (id: string,) => {




  return `/sites/${id}/record-transfer/preview`
}

/**
 * Записи Development с тем, на что они ссылаются, — что заведётся на Production, что обновится, сколько файлов скопируется и что мешает переносу (схема отличается).
 * @summary Что переедет вместе с записями
 */
export const recordTransferPreview = async (id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordTransferPreviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordTransferPreviewResponse>(getRecordTransferPreviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recordTransferInputBody)
  }
);}





export const getRecordTransferPreviewQueryKey = (id: string,
    recordTransferInputBody?: NonReadonly<RecordTransferInputBody>,) => {
    return [
    'POST', `/sites/${id}/record-transfer/preview`, recordTransferInputBody
    ] as const;
    }


export const getRecordTransferPreviewQueryOptions = <TData = Awaited<ReturnType<typeof recordTransferPreview>>, TError = ErrorModel>(id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordTransferPreviewQueryKey(id,recordTransferInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordTransferPreview>>> = ({ signal }) => recordTransferPreview(id,recordTransferInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordTransferPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordTransferPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof recordTransferPreview>>>
export type RecordTransferPreviewQueryError = ErrorModel


export function useRecordTransferPreview<TData = Awaited<ReturnType<typeof recordTransferPreview>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordTransferPreview>>,
          TError,
          Awaited<ReturnType<typeof recordTransferPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordTransferPreview<TData = Awaited<ReturnType<typeof recordTransferPreview>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordTransferPreview>>,
          TError,
          Awaited<ReturnType<typeof recordTransferPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordTransferPreview<TData = Awaited<ReturnType<typeof recordTransferPreview>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Что переедет вместе с записями
 */

export function useRecordTransferPreview<TData = Awaited<ReturnType<typeof recordTransferPreview>>, TError = ErrorModel>(
 id: string,
    recordTransferInputBody: NonReadonly<RecordTransferInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordTransferPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordTransferPreviewQueryOptions(id,recordTransferInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type schemaTransferPreviewResponse200 = {
  data: TransferPreviewOutputBody
  status: 200
}

export type schemaTransferPreviewResponse401 = {
  data: ErrorModel
  status: 401
}

export type schemaTransferPreviewResponse403 = {
  data: ErrorModel
  status: 403
}

export type schemaTransferPreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type schemaTransferPreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type schemaTransferPreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type schemaTransferPreviewResponseSuccess = (schemaTransferPreviewResponse200) & {
  headers: Headers;
};
export type schemaTransferPreviewResponseError = (schemaTransferPreviewResponse401 | schemaTransferPreviewResponse403 | schemaTransferPreviewResponse404 | schemaTransferPreviewResponse422 | schemaTransferPreviewResponse500) & {
  headers: Headers;
};

export type schemaTransferPreviewResponse = (schemaTransferPreviewResponseSuccess | schemaTransferPreviewResponseError)

export const getSchemaTransferPreviewUrl = (id: string,
    params: SchemaTransferPreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/schema-transfer?${stringifiedParams}` : `/sites/${id}/schema-transfer`
}

/**
 * Что поменяется у получателя, как это ляжет на его данные и на какие вопросы нужно ответить. Типы и поля сопоставляются по родословной: переименованное поле — изменение, а не «удалили и завели новое».
 * @summary Разница схем двух окружений
 */
export const schemaTransferPreview = async (id: string,
    params: SchemaTransferPreviewParams, options?: Parameters<typeof facetaFetch>[1]): Promise<schemaTransferPreviewResponse> => {

  return facetaFetch<schemaTransferPreviewResponse>(getSchemaTransferPreviewUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSchemaTransferPreviewQueryKey = (id: string,
    params?: SchemaTransferPreviewParams,) => {
    return [
    `/sites/${id}/schema-transfer`, ...(params ? [params] : [])
    ] as const;
    }


export const getSchemaTransferPreviewQueryOptions = <TData = Awaited<ReturnType<typeof schemaTransferPreview>>, TError = ErrorModel>(id: string,
    params: SchemaTransferPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchemaTransferPreviewQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schemaTransferPreview>>> = ({ signal }) => schemaTransferPreview(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schemaTransferPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchemaTransferPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof schemaTransferPreview>>>
export type SchemaTransferPreviewQueryError = ErrorModel


export function useSchemaTransferPreview<TData = Awaited<ReturnType<typeof schemaTransferPreview>>, TError = ErrorModel>(
 id: string,
    params: SchemaTransferPreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransferPreview>>,
          TError,
          Awaited<ReturnType<typeof schemaTransferPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransferPreview<TData = Awaited<ReturnType<typeof schemaTransferPreview>>, TError = ErrorModel>(
 id: string,
    params: SchemaTransferPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransferPreview>>,
          TError,
          Awaited<ReturnType<typeof schemaTransferPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransferPreview<TData = Awaited<ReturnType<typeof schemaTransferPreview>>, TError = ErrorModel>(
 id: string,
    params: SchemaTransferPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Разница схем двух окружений
 */

export function useSchemaTransferPreview<TData = Awaited<ReturnType<typeof schemaTransferPreview>>, TError = ErrorModel>(
 id: string,
    params: SchemaTransferPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchemaTransferPreviewQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type schemaTransferApplyResponse201 = {
  data: TransferBody
  status: 201
}

export type schemaTransferApplyResponse401 = {
  data: ErrorModel
  status: 401
}

export type schemaTransferApplyResponse403 = {
  data: ErrorModel
  status: 403
}

export type schemaTransferApplyResponse404 = {
  data: ErrorModel
  status: 404
}

export type schemaTransferApplyResponse409 = {
  data: ErrorModel
  status: 409
}

export type schemaTransferApplyResponse412 = {
  data: ErrorModel
  status: 412
}

export type schemaTransferApplyResponse422 = {
  data: ErrorModel
  status: 422
}

export type schemaTransferApplyResponse500 = {
  data: ErrorModel
  status: 500
}

export type schemaTransferApplyResponseSuccess = (schemaTransferApplyResponse201) & {
  headers: Headers;
};
export type schemaTransferApplyResponseError = (schemaTransferApplyResponse401 | schemaTransferApplyResponse403 | schemaTransferApplyResponse404 | schemaTransferApplyResponse409 | schemaTransferApplyResponse412 | schemaTransferApplyResponse422 | schemaTransferApplyResponse500) & {
  headers: Headers;
};

export type schemaTransferApplyResponse = (schemaTransferApplyResponseSuccess | schemaTransferApplyResponseError)

export const getSchemaTransferApplyUrl = (id: string,) => {




  return `/sites/${id}/schema-transfer`
}

/**
 * Переносит выбранные изменения одной транзакцией. Перед этим снимает снимок схемы получателя — по нему перенос откатывается. Версии схем — из предпросмотра: схема успела поменяться — 412, разницу надо посмотреть снова.
 * @summary Перенести схему
 */
export const schemaTransferApply = async (id: string,
    transferApplyInputBody: NonReadonly<TransferApplyInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<schemaTransferApplyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<schemaTransferApplyResponse>(getSchemaTransferApplyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(transferApplyInputBody)
  }
);}





export const getSchemaTransferApplyQueryKey = (id: string,
    transferApplyInputBody?: NonReadonly<TransferApplyInputBody>,) => {
    return [
    'POST', `/sites/${id}/schema-transfer`, transferApplyInputBody
    ] as const;
    }


export const getSchemaTransferApplyQueryOptions = <TData = Awaited<ReturnType<typeof schemaTransferApply>>, TError = ErrorModel>(id: string,
    transferApplyInputBody: NonReadonly<TransferApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchemaTransferApplyQueryKey(id,transferApplyInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schemaTransferApply>>> = ({ signal }) => schemaTransferApply(id,transferApplyInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schemaTransferApply>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchemaTransferApplyQueryResult = NonNullable<Awaited<ReturnType<typeof schemaTransferApply>>>
export type SchemaTransferApplyQueryError = ErrorModel


export function useSchemaTransferApply<TData = Awaited<ReturnType<typeof schemaTransferApply>>, TError = ErrorModel>(
 id: string,
    transferApplyInputBody: NonReadonly<TransferApplyInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferApply>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransferApply>>,
          TError,
          Awaited<ReturnType<typeof schemaTransferApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransferApply<TData = Awaited<ReturnType<typeof schemaTransferApply>>, TError = ErrorModel>(
 id: string,
    transferApplyInputBody: NonReadonly<TransferApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferApply>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransferApply>>,
          TError,
          Awaited<ReturnType<typeof schemaTransferApply>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransferApply<TData = Awaited<ReturnType<typeof schemaTransferApply>>, TError = ErrorModel>(
 id: string,
    transferApplyInputBody: NonReadonly<TransferApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Перенести схему
 */

export function useSchemaTransferApply<TData = Awaited<ReturnType<typeof schemaTransferApply>>, TError = ErrorModel>(
 id: string,
    transferApplyInputBody: NonReadonly<TransferApplyInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransferApply>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchemaTransferApplyQueryOptions(id,transferApplyInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type schemaTransfersResponse200 = {
  data: TransfersOutputBody
  status: 200
}

export type schemaTransfersResponse401 = {
  data: ErrorModel
  status: 401
}

export type schemaTransfersResponse403 = {
  data: ErrorModel
  status: 403
}

export type schemaTransfersResponse404 = {
  data: ErrorModel
  status: 404
}

export type schemaTransfersResponse422 = {
  data: ErrorModel
  status: 422
}

export type schemaTransfersResponse500 = {
  data: ErrorModel
  status: 500
}

export type schemaTransfersResponseSuccess = (schemaTransfersResponse200) & {
  headers: Headers;
};
export type schemaTransfersResponseError = (schemaTransfersResponse401 | schemaTransfersResponse403 | schemaTransfersResponse404 | schemaTransfersResponse422 | schemaTransfersResponse500) & {
  headers: Headers;
};

export type schemaTransfersResponse = (schemaTransfersResponseSuccess | schemaTransfersResponseError)

export const getSchemaTransfersUrl = (id: string,) => {




  return `/sites/${id}/schema-transfers`
}

/**
 * @summary История переносов схемы
 */
export const schemaTransfers = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<schemaTransfersResponse> => {

  return facetaFetch<schemaTransfersResponse>(getSchemaTransfersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSchemaTransfersQueryKey = (id: string,) => {
    return [
    `/sites/${id}/schema-transfers`
    ] as const;
    }


export const getSchemaTransfersQueryOptions = <TData = Awaited<ReturnType<typeof schemaTransfers>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransfers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchemaTransfersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schemaTransfers>>> = ({ signal }) => schemaTransfers(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schemaTransfers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchemaTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof schemaTransfers>>>
export type SchemaTransfersQueryError = ErrorModel


export function useSchemaTransfers<TData = Awaited<ReturnType<typeof schemaTransfers>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransfers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransfers>>,
          TError,
          Awaited<ReturnType<typeof schemaTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransfers<TData = Awaited<ReturnType<typeof schemaTransfers>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransfers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schemaTransfers>>,
          TError,
          Awaited<ReturnType<typeof schemaTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchemaTransfers<TData = Awaited<ReturnType<typeof schemaTransfers>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransfers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary История переносов схемы
 */

export function useSchemaTransfers<TData = Awaited<ReturnType<typeof schemaTransfers>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schemaTransfers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchemaTransfersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






